import { render, staticRenderFns } from "./VerificationForm.vue?vue&type=template&id=2d77920e&scoped=true"
import script from "./VerificationForm.vue?vue&type=script&lang=js"
export * from "./VerificationForm.vue?vue&type=script&lang=js"
import style0 from "./VerificationForm.vue?vue&type=style&index=0&id=2d77920e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77920e",
  null
  
)

export default component.exports